import React from "react";
import { AppList } from "components/list/AppList";
import {
	Datagrid,
	usePermissions,
	TextField,
	ReferenceField,
	ChipField,
	SingleFieldList,
	ReferenceArrayField,
} from "react-admin";

import { DateFormatField } from "../../../components/fields/DateFormatField";
import { UserRole } from "../../../entities/UserRole";
import { OrdersByAPIListFilter } from "./ListFilters";
import { getFilterDefault } from "../../../components/filters/MonthRangeFilter";
import ChipArrayField from "components/fields/ChipArrayField";
import { ThirdPartyField } from "components/fields/ThirdPartyField";


const defaultSort = { field: "completed_at", order: "DESC" };

export const OrdersByAPIList = (props) => {
	const { permissions } = usePermissions();

	if (!permissions) return null;

	const isDeveloper = permissions.role == UserRole.developer;

	return (
		<AppList
			{...props}
			exporter={false}
			empty={false}
			bulkActionButtons={false}
			sort={defaultSort}
			filters={<OrdersByAPIListFilter isDeveloper={isDeveloper} />}
			filterDefaultValues={getFilterDefault()}
		>
			<Datagrid>
				<DateFormatField source="completed_at" withLocalTimeZone />
				{!isDeveloper ?
					<TextField source="oauth2_client_name" />
				:
					<ThirdPartyField source="oauth2_client_id" link />
				}
				{!isDeveloper ? 
					<ReferenceField
						source="company_id"
						reference="customer-companies"
						link={true}
					>
						<TextField source="full_name" />
					</ReferenceField>
				: 
					<TextField source="company_customer_name" />
				}
				{!isDeveloper ?
					<ReferenceArrayField 
						reference="orders" 
						target="selected_ids"
						source="order_ids"
						sortable={false}
					>
						<SingleFieldList linkType="show" style={{ display: "block" }}>
							<ChipField source="id" size="small" />
						</SingleFieldList>
					</ReferenceArrayField>
				: 
					<ChipArrayField source="order_ids" sortable={false} />
				}
			</Datagrid>
		</AppList>
	);
};
